<div class="center">
  <div>Education</div>
  <div>Still working on this page!</div>
</div>
